import styled, { css } from 'styled-components';
import media from '../../../constants/media';
import theme from '../../../constants/theme';
import DynamicRspImage from '../../base/images/dynamicRspImageBg';
import { A } from '../../base/typography';

export const Wrapper = styled.div`
	margin-bottom: 14rem;

	svg {
		fill: ${theme.colors.black};
	}

	${media.mobileOnly`
		margin: 0 -2rem 14rem -2rem;
	`}

	${media.tablet`
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 2rem;
	`}

  ${media.desktopSmall`
		column-gap: 10rem;
	`}
`;

export const LoginModalWrapper = styled.div`
	margin: -20rem 2rem 0 2rem;
	box-shadow: 0px 11px 24px #ececec;
	background: white;
	${media.mobileAndTabletOnly`
		padding: 2rem 3rem;
	`}

	h2 {
		text-align: center;
		padding: 5rem 0;
	}

	input {
		margin-bottom: 2rem;
	}

	> p {
		display: none;
	}

	${media.tablet`
		box-shadow: inherit;
		margin: 0;

		h2 {
			text-align: left;
		}

		> p {
			display: inherit;
		}
	`}
`;

export const ButtonWrapper = styled.div`
	margin-bottom: 2rem;
	width: 100%;

	button {
		width: 100%;
	}
`;

export const RegisterWrapper = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const HeadingImage = styled(DynamicRspImage)`
	padding-bottom: 80%;
	z-index: -100;
	${media.tablet`
		display: none;
	`}
`;

export const Tabs = styled.div`
	display: grid;
	grid-template-columns: repeat(3, minmax(auto, 100%));
	align-items: stretch;
	height: 5.2rem;
	border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
	overflow-y: hidden;
	overflow-x: auto;
	/* ios specific: */
	@supports (-webkit-overflow-scrolling: touch) {
		overflow-x: scroll;
	}

	justify-content: center;
	border-bottom: inherit;
	overflow: inherit;

	margin-bottom: 2rem;
`;

export const Tab = styled(A)`
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 0 0 auto;
	margin-bottom: -1px;
	padding: 0 2px;
	color: ${({ theme }) => theme.colors.black};
	border-bottom-width: 2px;
	border-bottom-style: solid;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	transition: border-color 150ms;
	cursor: pointer;
	border-color: ${({ theme }) => theme.colors.borderColor};
	text-align: center;

	${media.mobileMedium`
    	white-space: nowrap;
    	`}
	${media.tablet`
		padding: 0 2rem;
	`}

	&:hover {
		border-color: ${({ theme }) => theme.colors.borderDark};
		color: ${({ theme }) => theme.colors.black};
	}

	${({ active }) =>
		active &&
		css`
			border-color: ${({ theme }) => theme.colors.primary};

			&:hover {
				border-color: ${({ theme }) => theme.colors.primaryDark};
			}
		`};

	${({ disabled, active }) => !active && disabled && css`
		color: ${({ theme }) => theme.colors.grayLight};
		&:hover {
				border-color: unset;
        color: ${({ theme }) => theme.colors.grayLight};
		}
	`}
`;

export const SideWrapper = styled.div`
	align-items: center;
	justify-content: center;
	background-color: ${({ theme }) => theme.colors.primary};
	display: none;
	svg {
		padding: 0 1rem 0 1rem;
		max-width: 400px;
	}

	${media.tablet`
		display: flex;
	`}
	${media.desktopHuge`
		svg {
			max-width: 650px;
		}
	`}
`;

export const MobileDemo = styled.div`
	${media.mobileAndTabletOnly`
		display: none;
	`}

	position: absolute;
	top: 5rem;
	left: calc(50% - 18rem);
	z-index: 10;
	margin: auto;
	background-color: #333;
	border: 10px #333 solid;
	border-top-width: 60px;
	border-bottom-width: 50px;
	border-radius: 36px;
	-webkit-box-shadow: 6px 6px 10px 0px rgba(0, 0, 0, 0.14);
	-moz-box-shadow: 6px 6px 10px 0px rgba(0, 0, 0, 0.14);
	box-shadow: 6px 6px 10px 0px rgba(0, 0, 0, 0.14);

	:before {
		content: '';
		display: block;
		width: 5rem;
		height: 5px;
		position: absolute;
		top: -30px;
		left: 50%;
		transform: translate(-50%, -50%);
		background: rgba(0, 0, 0, 0.5);
		border-radius: 10px;
	}
`;
export const MobileContent = styled.div`
	// Resolution: 888x1920
	width: calc(37rem / 1.5);
	height: calc(80rem / 1.5);
	background: black;
	border-radius: 5px;

	iframe,
	video {
		width: 100%;
		height: 100%;
		border-radius: 5px;
	}
`;

export const AppButtons = styled.div`
	display: flex;
	${media.tablet`
	padding-left: 5rem;
	`}
	${media.desktopLarge`
	padding-left: 15rem;
	`}
`;
export const AppButton = styled(A)`
	background-color: white;
	padding: 1rem 2rem 1rem 1.5rem;
	border-radius: 10px;
	display: flex;
	margin-right: 2rem;
	line-height: 1.2;
	svg {
		height: 3.2rem;
		width: 3.2rem;
	}
`;
export const AppButtonText = styled.span`
	display: flex;
	flex-direction: column;
	margin-left: 1rem;
`;
export const AppButtonMainText = styled.span`
	color: black;
	font-size: 1.4rem;
`;
export const AppButtonSubtext = styled.span`
	color: #626e77;
	font-size: 1.4rem;
`;
